export default {
      id: "tick-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#tick",
      toString: function () {
        return this.url;
      }
    }